import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import TournamentAnnouncesSMStream from '../streams/tournament/TournamentAnnouncesSMStream';
import TournamentBasicSMStream from '../streams/tournament/TournamentBasicSMStream';

import { browserHistory } from 'react-router';
import { fetchRoundEventsForStageKey, fetchRoundEventsForStage } from '../../../actions/events';
import { EventsList } from './views/EventsList';

class StageRoundSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        let {
            dispatch,
            fetchRoundEventsForStage,
            params: { round, stageId }
        } = this.props;

        dispatch(fetchRoundEventsForStage(stageId, round));
    };

    componentWillReceiveProps = nextProps => {
        let { dispatch, fetchLatestEventsForStage, params } = this.props;

        if (
            +this.props.params.stageId !== +nextProps.params.stageId ||
            this.props.params.round + '' !== nextProps.params.round + ''
        ) {
            dispatch(fetchRoundEventsForStage(+nextProps.params.stageId, nextProps.params.round));
        }
    };

    render() {
        let {
            params: { tournamentId, seasonId, sport, round, eventId },
            tournament,
            stage,
            events = []
        } = this.props;

        return (
            <div>
                <div>
                    <EventsList events={events} eventId={eventId} />
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        let { stageId, round } = props.params;
        let ids = _.get(state, `query.entities[${fetchRoundEventsForStageKey(stageId, round)}]`, []);

        let events = _.get(state, `query.entities.events`, []);

        return {
            events: ids.map(id => events[id]),
            tournament: _.get(state.smBrowser, 'tournament'),
            stages: _.get(state.smBrowser, 'season.stages', []),
            stage: _.chain(state.smBrowser)
                .get('season.stages', [])
                .find(s => +s.id === +props.params.stageId)
                .value()
        };
    },
    dispatch => ({
        dispatch,
        fetchRoundEventsForStage
    })
)(StageRoundSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentRoundHost.js
 **/